<template>
	<b-modal ref="modalMovimentiContabili" :title="modalTitolo" size="xl" style="height: 100%" no-close-on-backdrop no-close-on-esc centered>
		<b-row>
			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Descrizione Movimento</label>
				<b-form-input v-model="jsonDataMovimentiContabili.descrizioneMovimento"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Data Ora</label>
				<date-picker v-model="jsonDataMovimentiContabili.dataOra" :disabled-date="notAfter" format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime"></date-picker>
			</b-col>

			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Tipo Movimento</label>
				<b-form-select v-model="jsonDataMovimentiContabili.tipoMovimento">
					<b-form-select-option :value="-1">Pagamenti</b-form-select-option>
					<b-form-select-option :value="1">Versamenti</b-form-select-option>
				</b-form-select>
			</b-col>

			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Importo (€)</label>
				<b-form-input v-model="jsonDataMovimentiContabili.importo" type="number" min="0" step="0.01"></b-form-input>
			</b-col>

			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note</label>
				<b-form-textarea v-model="jsonDataMovimentiContabili.note" max-rows="10" rows="7"></b-form-textarea>
			</b-col>
		</b-row>
		<template #modal-footer>
			<b-button @click="onChiudiModale" size="md" class="no-text" variant="outline-danger">Annulla</b-button>
			<b-button @click="onSalvaMovimentiContabili" variant="outline-success">Salva</b-button>
		</template>
		<modal-error ref="cmpModalError"></modal-error>
	</b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
	mixins: [UtilityMixin],
	components: { DatePicker, ModalError },
	props: {
		idAccettazione: {
			type: String,
			required: true,
		},
	},

	data() {
		return {
			modalTitolo: null,
			listKey: 0,
			pathResource: "/rsamovimenticontabili",
			jsonDataMovimentiContabili: {
				id: null,
				idAccettazione: this.idAccettazione,
				descrizioneMovimento: null,
				tipoMovimento: 0,
				importo: 0,
				note: null,
			},
		};
	},

	methods: {
		show(item) {
			let me = this;
			me.jsonDataMovimentiContabili = item;
			if (me.jsonDataMovimentiContabili.id === null) {
				(me.modalTitolo = "Nuovo Movimento Contabile"),
					(me.jsonDataMovimentiContabili = {
						id: null,
						descrizioneMovimento: null,
						tipoMovimento: null,
						importo: 0,
						note: null,
					});
				me.jsonDataMovimentiContabili.idAccettazione = item.idAccettazione;
			} else {
				let me = this;
				me.modalTitolo = "Modifica Movimento Contabile";
				me.jsonDataMovimentiContabili = item;
				me.jsonDataMovimentiContabili.importo = Math.abs(me.jsonDataMovimentiContabili.importo);
			}
			this.$refs.modalMovimentiContabili.show();
		},
		onSalvaMovimentiContabili() {
			let me = this;
			if (!me.jsonDataMovimentiContabili.idAccettazione) {
				me.$bvToast.toast("Errore: ID Accettazione mancante", {
					title: "Errore",
					variant: "danger",
					solid: true,
				});
				return;
			}
			//me.jsonDataMovimentiContabili.importo = me.jsonDataMovimentiContabili.tipoMovimento * me.jsonDataMovimentiContabili.importo;
			UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataMovimentiContabili, me.salvaMovimentiContabiliSuccess, me.salvaMovimentiContabiliError);
		},
		salvaMovimentiContabiliSuccess() {
			let me = this;
			me.$refs.modalMovimentiContabili.hide();
			me.$bvToast.toast("Salvataggio avvenuto con successo", {
				title: "Successo",
				variant: "success",
				solid: true,
			});
			me.$emit("aggiornamentoSalvato");
		},
		salvaMovimentiContabiliError(error) {
			let me = this;
			me.$refs.cmpModalError.show(error.response.data.messaggio);
		},
		onChiudiModale() {
			let me = this;
			me.jsonDataMovimentiContabili.importo = me.jsonDataMovimentiContabili.tipoMovimento * me.jsonDataMovimentiContabili.importo;
			me.$refs.modalMovimentiContabili.hide();
		},
	},
};
</script>
